/** @format */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addManagerAction } from "../../../services/managers";
import { hideExpense, hideManger } from "../../../store/stateSlice";
import { alertMsg } from "../../../utilities/helper";
import Popup from "../../global/form create/Popup";
import InputField from "../../inputs/inputField";

import InputPassword from "../../inputs/inputPassword";
import UploadPhoto from "../../inputs/UploadPhoto";
const AddManger = ({ isOpen, toggleModal, getManagers }) => {
  //view pupup when onclick "اضافه مشرف"
  // const viewPupup = useSelector((state) => state.toggleState.value.newMangers);
  const dispatch = useDispatch();
  const hidePupup = () => {
    dispatch(hideManger());
  };
  // handel data form

  const [values, setValues] = useState({
    photo: "",
    email: "",
    name: "",
    phone_number: "",
    password: "",
  });
  useEffect(() => {
    setValues({
      photo: "",
      email: "",
      name: "",
      phone_number: "",
      password: "",
    });
  }, [isOpen]);
  // State to store uploaded file
  const [file, setFile] = useState("");

  // Handles file upload event and updates state
  function handleUpload(event) {
    setFile(event.target.files[0]);
  }
  const add = () => {
    const { email, name, phone_number, password } = values;
    if (email.length && name.length && phone_number && password.length) {
      dispatch(
        addManagerAction({
          url: "/moderators/register",
          params: { ...values, photo: file },
        })
      ).then((res) => {
        alertMsg("تم اضافه المشرف بنجاح  ", true);
        getManagers();
        toggleModal(false);
      });
    } else {
      alertMsg("اكمل  باقي لبيانات ", false);
    }
  };
  return (
    <Popup viewPupup={isOpen} hidePupup={toggleModal} viewWidth='content-xl'>
      <form className='main-contnt'>
        <div className='head-content'>
          <UploadPhoto
            name='addManger'
            handleUpload={handleUpload}
            file={file}
          />
        </div>
        <div className='body-content'>
          <InputField
            value={values.name}
            title='الاسم'
            placeholder='اكتب الاسم '
            onChange={(event) =>
              setValues({ ...values, name: event.target.value })
            }
          />
          <InputField
            title='البريد الالكتروني'
            placeholder='اكتب البريد الالكتروني'
            note='*'
            type='email'
            value={values.email}
            onChange={(event) =>
              setValues({ ...values, email: event.target.value })
            }
          />
          <InputField
            title='رقم الموبيل '
            placeholder='اكتب رقم الموبيل'
            note='*'
            type='number'
            value={values.phone_number}
            onChange={(event) =>
              setValues({ ...values, phone_number: event.target.value })
            }
          />
          <InputPassword
            title='الرقم السري '
            placeholder='اكتب الرقم السري *'
            note='*'
            value={values.password}
            onChange={(event) =>
              setValues({ ...values, password: event.target.value })
            }
          />
        </div>
        <div className='buttons-contnt display-flex center-flex '>
          <div class='btn btn__primary' onClick={add}>
            اضافه
          </div>
          <div class='btn btn__danger' onClick={toggleModal}>
            الغاء
          </div>
        </div>
      </form>
    </Popup>
  );
};

export default AddManger;
